var hasOwnProp = Object.prototype.hasOwnProperty;
export default hasOwnProp;
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/hasOwnProp.js.01-babel.map